(() => {
  if (window.cyChristmasDownloadReady) return;
  window.cyChristmasDownloadReady = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-cy-christmas-download]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      // A blob URL allows download even when Shopify serves assets on its CDN.
      const response = await fetch(link.href);
      if (!response.ok) throw new Error('Download unavailable');
      const url = URL.createObjectURL(await response.blob());
      const download = document.createElement('a');
      download.href = url;
      download.download = link.download;
      document.body.appendChild(download);
      download.click();
      download.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      // Keep the original Excel link usable if fetching is blocked.
      window.location.assign(link.href);
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
